import script from "./AccessBannedWarningMolecule.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessBannedWarningMolecule.vue?vue&type=script&setup=true&lang=js"

import "./AccessBannedWarningMolecule.vue?vue&type=style&index=0&id=4b1f6f7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b1f6f7c"]])

export default __exports__